import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page23() {
  useEffect(() => {
    document.title = "Маяк — Страница 22"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page21" />
        <ForwardLink href="/page23" />
      </div>

      <p style={{ textAlign: "right" }}>22.</p>
      <p>Он мастурбирует.</p>
      <p>КАМЕРА ПОДЪЕЗЖАЕТ К: голове МОЛОДОГО и...</p>
      <p>ЧЕРНЫЙ ЭКРАН.</p>
      <br/>
      <p>СНАРУЖИ. САРАЙ – ЧУТЬ ПОЗЖЕ ТОЙ ЖЕ НОЧЬЮ</p>
      <p>
        МОЛОДОЙ выходит из темноты сарая, курит. Он<br/>
        закрывает за собой дверь и прислоняется к ней. Вздыхает.<br/>
        Спокойно. Он спокоен.
      </p>
      <p>
        СВЕТ МАЯКА освещает МОЛОДОГО волнами горячих белых<br/>
        полос, иначе: мягкий свет сигареты указывает<br/>
        на его местонахождение в темноте.
      </p>
      <p>
        Внезапно он замечает что-то странное, ТЕМНОЕ ПЯТНО в центре<br/>
        света. В полосах света, падающих на него<br/>
        тень МУЖСКОГО СИЛУЭТА. МОЛОДОЙ смотрит на башню:
      </p>
      <p>С ТОЧКИ ЗРЕНИЯ (POV – Point of view) МОЛОДОГО: Это СТАРИК... <i>обнимает линзы?</i></p>
      <p>МОЛОДОЙ поражен, растерян. Он смотрит снова.</p>
      <p>
        С ТОЧКИ ЗРЕНИЯ МОЛОДОГО: Каким-то образом, СТАРИК оказывается на ПОДИУМЕ (смотровой площадке). Наблюдает.<br/>
        Он натягивает на плечи подтяжки, будто одеваясь<br/>
        после ночи с женщиной. Фонарь в другой руке помогает<br/>
        ему смотреть вниз...
      </p>
      <p>
        МОЛОДОЙ прячется под карнизом крыши, опасаясь человека<br/>
        наверху. Он тушит светящуюся сигарету... Прячется.
      </p>
      <br/>
      <p>ПРОПУЩЕНО</p>
      <br/>
      <p>ПРОПУЩЕНО</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – ДЕНЬ</p>
      <p>
        ЧРЕЗВЫЧАЙНО ШИРОКИЙ ПЛАН: МОЛОДОЙ толкает тачку сквозь<br/>
        шторм, уголь накрыт клеенчатым брезентом. (Прошло время, его<br/>
        фингал зажил.) Он пробирается сквозь грязь...
      </p>
      <p>Задержка.</p>
      <p>АУДИО ПРЕЛАП:</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты пренебрегаешь своими обязанностями,<br/>
        парень!
      </p>
      <p style={{ textAlign: "right" }}>22.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page21" />
        <ForwardLink href="/page23" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710013483/the-lighthouse-script/horteziqufddfcpezmre.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page23;
